import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';


const ImageClicksViewer = (props) => {
  const [data, setData] = useState([])

  useEffect(() => {
    //we take the two props props.images & props.clicks
    //and merge them in one object with all we need
    if (props.images && props.clicks) {
      const newData = []
      props.images.forEach((img, index) => {
        const matchedClicks = props.clicks.find(c => c.offerIndex === index)
        if (matchedClicks) newData.push({imgB64: img.imgB64, clicks: matchedClicks.totalClicks})
        else newData.push({imgB64: img.imgB64, clicks: 0})
      });
      setData(newData)
    }

  }, [props.images, props.clicks])

  return <div className='flex flex-row flex-wrap gap-4'>
      {data.map(d => <div className='flex flex-col gap-y-1 items-center'>
        <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex justify-center'>
            <div className='relative h-full' >

                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${d.imgB64}`} />

            </div>
          </div>
          <div className='bg-ccColorDarkTeal text-white font-semibold font-poppins text-sm w-fit rounded px-2 py-1'>Clicks: {d.clicks}</div>        
      </div>)

      }
  </div>
}

export default function SnippetScratchOffReport() {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [snippetBaseStats, setSnippetBaseStats] = useState(undefined)
    const [snippetWebPageStats, setSnippetWebPageStats] = useState(undefined)
    const [snippetRevealImages, setSnippetRevealImages] = useState([]) //convenient: it is parsed version of a json string that is available in snippetInfo

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetBaseStats(undefined)
        setSnippetWebPageStats(undefined)
        setSnippetInfo(undefined)
        getSnippetBaseStats(params.snippetId)
        getSnippetWebPageStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetBaseStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/base/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      setSnippetBaseStats(data)


    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetWebPageStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/WebPagesStats/base/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetWebPageStats(data)


    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)

      const snippetSettings = JSON.parse(data.snippetSettings)
      setSnippetRevealImages(snippetSettings.revealImages)
  


    } catch (error) {
      console.log(error);
    }
  }
  const getNumOffers = () => {
    if (snippetInfo === undefined) return undefined;

    //const snippetSettings = JSON.parse(snippetInfo.snippetSettings)

    return snippetRevealImages.length
  }
  const getWebPageClicks = () => {
    if (snippetWebPageStats === undefined) return undefined

    let result = 0;
    for (const row of snippetWebPageStats) {
        result += row.totalClicks
    }
    return result
  }

    return <div>
            <CcTitle>Element Report Scratch Off</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Email Image Views', value: snippetBaseStats ? snippetBaseStats.totalOpens : undefined },
                                    {title: 'Email Clicks', value: snippetBaseStats ? snippetBaseStats.totalClicks : undefined},
                                    {title: 'Web Page Clicks', value: getWebPageClicks()},
                                    {title: 'Number of reveal images', value: getNumOffers()},
                                    ]} />
            </div>
            <div className='mt-6 text-xl text-ccColorDarkTeal font-semibold'>Clicks per Reveal Image</div>
            <ImageClicksViewer images={snippetRevealImages} clicks={snippetWebPageStats} />
    </div>
}